import { X } from 'lucide-react';
import { useEffect } from 'react';

interface BottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  height?: string;
  title?: string;
}

export const BottomSheet: React.FC<BottomSheetProps> = ({
  isOpen,
  onClose,
  children,
  height = '70%',
  title,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black/40 z-40 animate-fadeIn"
        onClick={onClose}
      />

      {/* Sheet */}
      <div
        className="fixed left-0 right-0 bottom-0 rounded-t-2xl z-50 animate-slideUp flex flex-col"
        style={{
          backgroundColor: 'var(--bg-primary)',
          height,
          maxHeight: '96vh',
        }}
      >
        {/* Drag handle */}
        <div className="flex justify-center pt-3 pb-2 flex-shrink-0">
          <div
            className="w-10 h-1 rounded-full"
            style={{ backgroundColor: 'var(--bg-tertiary)' }}
          />
        </div>

        {/* Header */}
        {title && (
          <div
            className="flex items-center justify-between px-4 py-3 border-b flex-shrink-0"
            style={{ borderBottomColor: 'var(--separator)' }}
          >
            <h3
              className="text-[17px] font-semibold"
              style={{ color: 'var(--text-primary)' }}
            >
              {title}
            </h3>
            <button
              onClick={onClose}
              className="p-1 rounded-full hover:opacity-70 transition-opacity"
              style={{ color: 'var(--text-hint)' }}
            >
              <X size={24} />
            </button>
          </div>
        )}

        {/* Content */}
        <div className="px-4 overflow-y-auto flex-1 min-h-0">
          {children}
        </div>
      </div>
    </>
  );
};
